import styled from "styled-components";
import { Button } from "storybook/components/button";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const BannerContainer = styled.div`
  margin: 10px 0 20px 0;
`;

// @ts-ignore cannot resolve against default theme
export const ContinueButton = styled(Button).attrs({
  type: "submit",
  theme: "default",
  color: "secondary",
})<{ $isSubmitting: boolean }>`
  && {
    margin-right: ${({ $isSubmitting }) => ($isSubmitting ? "60px" : "0")};

    @media (min-width: 768px) {
      margin-right: 0;
    }
  }
`;

export const Row = styled.div`
  height: 100px;
`;
